import { useRef, useState } from "react";

import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { Loading } from "components/Loading/loading";
import { InventoryReceiptDetailForm } from "./components/InventoryReceiptDetailForm";
import { InventoryRemittanceDetailForm } from "./components/InventoryRemittanceDetailForm";

interface SalesInvoiceFormProps {
  onHide: () => void;
  warehouseIODetail?: any;
  mode: any;
  warehouseId: any;
  selectedObj?: any;
  WarehouseDetailId?: any;
  WarehouseDetail?:any,
  WarehouseDetailsCount?:any
  jobId?:any
  constraint?:any
  increaseOrDecrease?:number
  initialStock?:number
}

export const InventoryBalancingDetailForm = ({
  mode,
  onHide,
  warehouseIODetail,
  warehouseId,
  selectedObj,
  WarehouseDetailId,
  WarehouseDetail,
  WarehouseDetailsCount,
  jobId,
  constraint,
  initialStock
}: SalesInvoiceFormProps) => {

  const [loading, setLoading] = useState<any>(true);
  const [increaseOrDecrease, setIncreaseOrDecrease] = useState(selectedObj?.QtyIn1 && selectedObj?.QtyIn1>0?0 :selectedObj?.QtyOut1 && selectedObj?.QtyOut1>0?1:0); // 0=>increase and 1=>decrease
  const [resetForm, setResetForm] = useState(false);
 
const flag=useRef<boolean>(false)
 


  const handleSubmit = (data) => {
 

    warehouseIODetail?.(data);
    onHide && onHide();
  };





  

  return (
    <>
    {loading ?
     <div className="card " style={{ flexDirection: "row" }}>
     
      <div style={{ flexWrap: "nowrap" }} className="card-body ">


  <div className="me-1 row align-items-center">
                      <div className="col-auto">
                        <CheckableButton
                          // onchange={(e) =>{ e  && setIncreaseOrDecrease(0)}}
                          Change={(e) =>{ e  && setIncreaseOrDecrease(0);setResetForm(!resetForm);flag.current=true
                          }}
mode={mode}

                          defaultChecked={increaseOrDecrease == 0}
                          labelText={"increase"}
                          inputName={"increaseOrDecrease"}
                          type="radio"
                        />
                      </div>
                      <div className="col-auto">
                        <CheckableButton
                          // defaultChecked={IsDefault}
                          // onchange={(e) =>{mode!='view' && setIncreaseOrDecrease(1)}}
                          Change={(e) =>{mode!='view' && setIncreaseOrDecrease(1);setResetForm(!resetForm);flag.current=true}}
mode={mode}
                          labelText={"decrease"}
                          inputName={"increaseOrDecrease"}
                          type="radio"
                          defaultChecked={increaseOrDecrease == 1}
                        />
                      </div>
                    </div>

        
      {increaseOrDecrease == 0?
            <InventoryReceiptDetailForm 
            warehouseIODetail={warehouseIODetail}
            mode={mode}
            onHide={ onHide}
            warehouseId={warehouseId}
            WarehouseDetailId={WarehouseDetailId}
            WarehouseDetail={WarehouseDetail}
            WarehouseDetailsCount={WarehouseDetailsCount}
            selectedObj={selectedObj}
            jobId={jobId}
            handleSubmitData={handleSubmit}
            reload={resetForm}
            flag={flag.current}

/>
      :
      
      <InventoryRemittanceDetailForm
            warehouseIODetail={warehouseIODetail}
            mode={mode}
            onHide={onHide}
            WarehouseDetail={WarehouseDetail}
            warehouseId={warehouseId}
            WarehouseDetailId={WarehouseDetailId}
            selectedObj={selectedObj}
            jobId={jobId}
            WarehouseDetailsCount={WarehouseDetailsCount}
            constraint={constraint}
            handleSubmitData={handleSubmit}
            reload={resetForm}
            flag={flag.current}
            initialStock={initialStock}
      />
      
      }
        

      </div>
    </div>
    :<Loading/>}
    </>
   
  );
};
